import "core-js/modules/es.array.push.js";
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-045bec67"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "left fontCoarse",
  style: {
    "height": "25px",
    "align-items": "center",
    "display": "flex",
    "justify-content": "center"
  }
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content fontCoarse crsHeigh"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "u-batNum"
}, "1:0"), /*#__PURE__*/_createElementVNode("span", {
  class: "u-img"
}, [/*#__PURE__*/_createElementVNode("img", {
  alt: ""
})])], -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content fontCoarse crsHeigh"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "u-batNum"
}, "2:0"), /*#__PURE__*/_createElementVNode("span", {
  class: "u-img"
}, [/*#__PURE__*/_createElementVNode("img", {
  alt: ""
})])], -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content fontCoarse crsHeigh"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "u-batNum"
}, "2:1"), /*#__PURE__*/_createElementVNode("span", {
  class: "u-img"
}, [/*#__PURE__*/_createElementVNode("img", {
  alt: ""
})])], -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content fontCoarse crsHeigh"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "u-batNum"
}, "3:0"), /*#__PURE__*/_createElementVNode("span", {
  class: "u-img"
}, [/*#__PURE__*/_createElementVNode("img", {
  alt: ""
})])], -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content fontCoarse crsHeigh"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "u-batNum"
}, "3:1"), /*#__PURE__*/_createElementVNode("span", {
  class: "u-img"
}, [/*#__PURE__*/_createElementVNode("img", {
  alt: ""
})])], -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content fontCoarse crsHeigh"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "u-batNum"
}, "3:2"), /*#__PURE__*/_createElementVNode("span", {
  class: "u-img"
}, [/*#__PURE__*/_createElementVNode("img", {
  alt: ""
})])], -1));
const _hoisted_8 = {
  class: "content crsHeigh"
};
const _hoisted_9 = {
  class: "u-batNum"
};
const _hoisted_10 = {
  class: "u-img"
};
const _hoisted_11 = ["src"];
const _hoisted_12 = {
  class: "content crsHeigh"
};
const _hoisted_13 = {
  class: "u-batNum"
};
const _hoisted_14 = {
  class: "u-img"
};
const _hoisted_15 = ["src"];
const _hoisted_16 = {
  class: "content crsHeigh"
};
const _hoisted_17 = {
  class: "u-batNum"
};
const _hoisted_18 = {
  class: "u-img"
};
const _hoisted_19 = ["src"];
const _hoisted_20 = {
  class: "content crsHeigh"
};
const _hoisted_21 = {
  class: "u-batNum"
};
const _hoisted_22 = {
  class: "u-img"
};
const _hoisted_23 = ["src"];
const _hoisted_24 = {
  class: "content crsHeigh"
};
const _hoisted_25 = {
  class: "u-batNum"
};
const _hoisted_26 = {
  class: "u-img"
};
const _hoisted_27 = ["src"];
const _hoisted_28 = {
  class: "content crsHeigh"
};
const _hoisted_29 = {
  class: "u-batNum"
};
const _hoisted_30 = {
  class: "u-img"
};
const _hoisted_31 = ["src"];
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content fontCoarse crsHeigh"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "u-batNum"
}, "4:0"), /*#__PURE__*/_createElementVNode("span", {
  class: "u-img"
}, [/*#__PURE__*/_createElementVNode("img", {
  alt: ""
})])], -1));
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content fontCoarse crsHeigh"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "u-batNum"
}, "4:1"), /*#__PURE__*/_createElementVNode("span", {
  class: "u-img"
}, [/*#__PURE__*/_createElementVNode("img", {
  alt: ""
})])], -1));
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content fontCoarse crsHeigh"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "u-batNum"
}, "4:2"), /*#__PURE__*/_createElementVNode("span", {
  class: "u-img"
}, [/*#__PURE__*/_createElementVNode("img", {
  alt: ""
})])], -1));
const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content fontCoarse crsHeigh"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "u-batNum"
}, "5:0"), /*#__PURE__*/_createElementVNode("span", {
  class: "u-img"
}, [/*#__PURE__*/_createElementVNode("img", {
  alt: ""
})])], -1));
const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content fontCoarse crsHeigh"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "u-batNum"
}, "5:1"), /*#__PURE__*/_createElementVNode("span", {
  class: "u-img"
}, [/*#__PURE__*/_createElementVNode("img", {
  alt: ""
})])], -1));
const _hoisted_37 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content fontCoarse crsHeigh"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "u-batNum"
}, "5:2"), /*#__PURE__*/_createElementVNode("span", {
  class: "u-img"
}, [/*#__PURE__*/_createElementVNode("img", {
  alt: ""
})])], -1));
const _hoisted_38 = {
  class: "content crsHeigh"
};
const _hoisted_39 = {
  class: "u-batNum"
};
const _hoisted_40 = {
  class: "u-img"
};
const _hoisted_41 = ["src"];
const _hoisted_42 = {
  class: "content crsHeigh"
};
const _hoisted_43 = {
  class: "u-batNum"
};
const _hoisted_44 = {
  class: "u-img"
};
const _hoisted_45 = ["src"];
const _hoisted_46 = {
  class: "content crsHeigh"
};
const _hoisted_47 = {
  class: "u-batNum"
};
const _hoisted_48 = {
  class: "u-img"
};
const _hoisted_49 = ["src"];
const _hoisted_50 = {
  class: "content crsHeigh"
};
const _hoisted_51 = {
  class: "u-batNum"
};
const _hoisted_52 = {
  class: "u-img"
};
const _hoisted_53 = ["src"];
const _hoisted_54 = {
  class: "content crsHeigh"
};
const _hoisted_55 = {
  class: "u-batNum"
};
const _hoisted_56 = {
  class: "u-img"
};
const _hoisted_57 = ["src"];
const _hoisted_58 = {
  class: "content crsHeigh"
};
const _hoisted_59 = {
  class: "u-batNum"
};
const _hoisted_60 = {
  class: "u-img"
};
const _hoisted_61 = ["src"];
const _hoisted_62 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content fontCoarse crsHeigh"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "u-batNum"
}, "0:0"), /*#__PURE__*/_createElementVNode("span", {
  class: "u-img"
}, [/*#__PURE__*/_createElementVNode("img", {
  alt: ""
})])], -1));
const _hoisted_63 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content fontCoarse crsHeigh"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "u-batNum"
}, "1:1"), /*#__PURE__*/_createElementVNode("span", {
  class: "u-img"
}, [/*#__PURE__*/_createElementVNode("img", {
  alt: ""
})])], -1));
const _hoisted_64 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content fontCoarse crsHeigh"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "u-batNum"
}, "2:2"), /*#__PURE__*/_createElementVNode("span", {
  class: "u-img"
}, [/*#__PURE__*/_createElementVNode("img", {
  alt: ""
})])], -1));
const _hoisted_65 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content fontCoarse crsHeigh"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "u-batNum"
}, "3:3"), /*#__PURE__*/_createElementVNode("span", {
  class: "u-img"
}, [/*#__PURE__*/_createElementVNode("img", {
  alt: ""
})])], -1));
const _hoisted_66 = {
  class: "content crsHeigh"
};
const _hoisted_67 = {
  class: "u-batNum"
};
const _hoisted_68 = {
  class: "u-img"
};
const _hoisted_69 = ["src"];
const _hoisted_70 = {
  class: "content crsHeigh"
};
const _hoisted_71 = {
  class: "u-batNum"
};
const _hoisted_72 = {
  class: "u-img"
};
const _hoisted_73 = ["src"];
const _hoisted_74 = {
  class: "content crsHeigh"
};
const _hoisted_75 = {
  class: "u-batNum"
};
const _hoisted_76 = {
  class: "u-img"
};
const _hoisted_77 = ["src"];
const _hoisted_78 = {
  class: "content crsHeigh"
};
const _hoisted_79 = {
  class: "u-batNum"
};
const _hoisted_80 = {
  class: "u-img"
};
const _hoisted_81 = ["src"];
const _hoisted_82 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content fontCoarse crsHeigh"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "u-batNum"
}, "胜其他"), /*#__PURE__*/_createElementVNode("span", {
  class: "u-img"
}, [/*#__PURE__*/_createElementVNode("img", {
  alt: ""
})])], -1));
const _hoisted_83 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content fontCoarse crsHeigh"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "u-batNum"
}, "平其他"), /*#__PURE__*/_createElementVNode("span", {
  class: "u-img"
}, [/*#__PURE__*/_createElementVNode("img", {
  alt: ""
})])], -1));
const _hoisted_84 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content fontCoarse crsHeigh"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "u-batNum"
}, "负其他"), /*#__PURE__*/_createElementVNode("span", {
  class: "u-img"
}, [/*#__PURE__*/_createElementVNode("img", {
  alt: ""
})])], -1));
const _hoisted_85 = {
  class: "content crsHeigh"
};
const _hoisted_86 = {
  class: "u-batNum"
};
const _hoisted_87 = {
  class: "u-img"
};
const _hoisted_88 = ["src"];
const _hoisted_89 = {
  class: "content crsHeigh"
};
const _hoisted_90 = {
  class: "u-batNum"
};
const _hoisted_91 = {
  class: "u-img"
};
const _hoisted_92 = ["src"];
const _hoisted_93 = {
  class: "content crsHeigh"
};
const _hoisted_94 = {
  class: "u-batNum"
};
const _hoisted_95 = {
  class: "u-img"
};
const _hoisted_96 = ["src"];
const _hoisted_97 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content fontCoarse crsHeigh"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "u-batNum"
}, "0:1"), /*#__PURE__*/_createElementVNode("span", {
  class: "u-img"
}, [/*#__PURE__*/_createElementVNode("img", {
  alt: ""
})])], -1));
const _hoisted_98 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content fontCoarse crsHeigh"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "u-batNum"
}, "0:2"), /*#__PURE__*/_createElementVNode("span", {
  class: "u-img"
}, [/*#__PURE__*/_createElementVNode("img", {
  alt: ""
})])], -1));
const _hoisted_99 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content fontCoarse crsHeigh"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "u-batNum"
}, "1:2"), /*#__PURE__*/_createElementVNode("span", {
  class: "u-img"
}, [/*#__PURE__*/_createElementVNode("img", {
  alt: ""
})])], -1));
const _hoisted_100 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content fontCoarse crsHeigh"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "u-batNum"
}, "0:3"), /*#__PURE__*/_createElementVNode("span", {
  class: "u-img"
}, [/*#__PURE__*/_createElementVNode("img", {
  alt: ""
})])], -1));
const _hoisted_101 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content fontCoarse crsHeigh"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "u-batNum"
}, "1:3"), /*#__PURE__*/_createElementVNode("span", {
  class: "u-img"
}, [/*#__PURE__*/_createElementVNode("img", {
  alt: ""
})])], -1));
const _hoisted_102 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content fontCoarse crsHeigh"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "u-batNum"
}, "2:3"), /*#__PURE__*/_createElementVNode("span", {
  class: "u-img"
}, [/*#__PURE__*/_createElementVNode("img", {
  alt: ""
})])], -1));
const _hoisted_103 = {
  class: "content crsHeigh"
};
const _hoisted_104 = {
  class: "u-batNum"
};
const _hoisted_105 = {
  class: "u-img"
};
const _hoisted_106 = ["src"];
const _hoisted_107 = {
  class: "content crsHeigh"
};
const _hoisted_108 = {
  class: "u-batNum"
};
const _hoisted_109 = {
  class: "u-img"
};
const _hoisted_110 = ["src"];
const _hoisted_111 = {
  class: "content crsHeigh"
};
const _hoisted_112 = {
  class: "u-batNum"
};
const _hoisted_113 = {
  class: "u-img"
};
const _hoisted_114 = ["src"];
const _hoisted_115 = {
  class: "content crsHeigh"
};
const _hoisted_116 = {
  class: "u-batNum"
};
const _hoisted_117 = {
  class: "u-img"
};
const _hoisted_118 = ["src"];
const _hoisted_119 = {
  class: "content crsHeigh"
};
const _hoisted_120 = {
  class: "u-batNum"
};
const _hoisted_121 = {
  class: "u-img"
};
const _hoisted_122 = ["src"];
const _hoisted_123 = {
  class: "content crsHeigh"
};
const _hoisted_124 = {
  class: "u-batNum"
};
const _hoisted_125 = {
  class: "u-img"
};
const _hoisted_126 = ["src"];
const _hoisted_127 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content fontCoarse crsHeigh"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "u-batNum"
}, "0:4"), /*#__PURE__*/_createElementVNode("span", {
  class: "u-img"
}, [/*#__PURE__*/_createElementVNode("img", {
  alt: ""
})])], -1));
const _hoisted_128 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content fontCoarse crsHeigh"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "u-batNum"
}, "1:4"), /*#__PURE__*/_createElementVNode("span", {
  class: "u-img"
}, [/*#__PURE__*/_createElementVNode("img", {
  alt: ""
})])], -1));
const _hoisted_129 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content fontCoarse crsHeigh"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "u-batNum"
}, "2:4"), /*#__PURE__*/_createElementVNode("span", {
  class: "u-img"
}, [/*#__PURE__*/_createElementVNode("img", {
  alt: ""
})])], -1));
const _hoisted_130 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content fontCoarse crsHeigh"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "u-batNum"
}, "0:5"), /*#__PURE__*/_createElementVNode("span", {
  class: "u-img"
}, [/*#__PURE__*/_createElementVNode("img", {
  alt: ""
})])], -1));
const _hoisted_131 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content fontCoarse crsHeigh"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "u-batNum"
}, "1:5"), /*#__PURE__*/_createElementVNode("span", {
  class: "u-img"
}, [/*#__PURE__*/_createElementVNode("img", {
  alt: ""
})])], -1));
const _hoisted_132 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content fontCoarse crsHeigh"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "u-batNum"
}, "2:5"), /*#__PURE__*/_createElementVNode("span", {
  class: "u-img"
}, [/*#__PURE__*/_createElementVNode("img", {
  alt: ""
})])], -1));
const _hoisted_133 = {
  class: "content crsHeigh"
};
const _hoisted_134 = {
  class: "u-batNum"
};
const _hoisted_135 = {
  class: "u-img"
};
const _hoisted_136 = ["src"];
const _hoisted_137 = {
  class: "content crsHeigh"
};
const _hoisted_138 = {
  class: "u-batNum"
};
const _hoisted_139 = {
  class: "u-img"
};
const _hoisted_140 = ["src"];
const _hoisted_141 = {
  class: "content crsHeigh"
};
const _hoisted_142 = {
  class: "u-batNum"
};
const _hoisted_143 = {
  class: "u-img"
};
const _hoisted_144 = ["src"];
const _hoisted_145 = {
  class: "content crsHeigh"
};
const _hoisted_146 = {
  class: "u-batNum"
};
const _hoisted_147 = {
  class: "u-img"
};
const _hoisted_148 = ["src"];
const _hoisted_149 = {
  class: "content crsHeigh"
};
const _hoisted_150 = {
  class: "u-batNum"
};
const _hoisted_151 = {
  class: "u-img"
};
const _hoisted_152 = ["src"];
const _hoisted_153 = {
  class: "content crsHeigh"
};
const _hoisted_154 = {
  class: "u-batNum"
};
const _hoisted_155 = {
  class: "u-img"
};
const _hoisted_156 = ["src"];
import { ref } from 'vue';
export default {
  __name: 'CrsView',
  setup(__props, {
    expose: __expose
  }) {
    const ttgList = ref([]);
    const changeList = ref([]);
    const pushCrsList = list => {
      ttgList.value = list;
      if (list.length > 0) {
        let up = "https://static.sporttery.cn/res_1_0/jcw/images/fotBasbal_match/icon_sjt.png";
        let down = "https://static.sporttery.cn/res_1_0/jcw/images/fotBasbal_match/icon_xjt.png";
        let init = list[0];
        let last = list[list.length - 1];
        let change = [];
        let s01s00f = 0;
        let s02s00f = 0;
        let s02s01f = 0;
        let s03s00f = 0;
        let s03s01f = 0;
        let s03s02f = 0;
        let s04s00f = 0;
        let s04s01f = 0;
        let s04s02f = 0;
        let s05s00f = 0;
        let s05s01f = 0;
        let s05s02f = 0;
        let s00s00f = 0;
        let s01s01f = 0;
        let s02s02f = 0;
        let s03s03f = 0;
        let s1shf = 0;
        let s1sdf = 0;
        let s1saf = 0;
        let s00s01f = 0;
        let s00s02f = 0;
        let s01s02f = 0;
        let s00s03f = 0;
        let s01s03f = 0;
        let s02s03f = 0;
        let s00s04f = 0;
        let s01s04f = 0;
        let s02s04f = 0;
        let s00s05f = 0;
        let s01s05f = 0;
        let s02s05f = 0;
        change.push({
          name: "初始:" + init.updateDate + "  " + init.updateTime,
          s01s00: init.s01s00,
          s02s00: init.s02s00,
          s02s01: init.s02s01,
          s03s00: init.s03s00,
          s03s01: init.s03s01,
          s03s02: init.s03s02,
          s04s00: init.s04s00,
          s04s01: init.s04s01,
          s04s02: init.s04s02,
          s05s00: init.s05s00,
          s05s01: init.s05s01,
          s05s02: init.s05s02,
          s00s00: init.s00s00,
          s01s01: init.s01s01,
          s02s02: init.s02s02,
          s03s03: init.s03s03,
          s1sh: init['s-1sh'],
          s1sd: init['s-1sd'],
          s1sa: init['s-1sa'],
          s00s01: init.s00s01,
          s00s02: init.s00s02,
          s01s02: init.s01s02,
          s00s03: init.s00s03,
          s01s03: init.s01s03,
          s02s03: init.s02s03,
          s00s04: init.s00s04,
          s01s04: init.s01s04,
          s02s04: init.s02s04,
          s00s05: init.s00s05,
          s01s05: init.s01s05,
          s02s05: init.s02s05,
          s01s00f: s01s00f,
          s02s00f: s02s00f,
          s02s01f: s02s01f,
          s03s00f: s03s00f,
          s03s01f: s03s01f,
          s03s02f: s03s02f,
          s04s00f: s04s00f,
          s04s01f: s04s01f,
          s04s02f: s04s02f,
          s05s00f: s05s00f,
          s05s01f: s05s01f,
          s05s02f: s05s02f,
          s00s00f: s00s00f,
          s01s01f: s01s01f,
          s02s02f: s02s02f,
          s03s03f: s03s03f,
          s1shf: s1shf,
          s1sdf: s1sdf,
          s1saf: s1saf,
          s00s01f: s00s01f,
          s00s02f: s00s02f,
          s01s02f: s01s02f,
          s00s03f: s00s03f,
          s01s03f: s01s03f,
          s02s03f: s02s03f,
          s00s04f: s00s04f,
          s01s04f: s01s04f,
          s02s04f: s02s04f,
          s00s05f: s00s05f,
          s01s05f: s01s05f,
          s02s05f: s02s05f
        });
        s01s00f = parseFloat(init.s01s00) > parseFloat(last.s01s00) ? down : parseFloat(init.s01s00) < parseFloat(last.s01s00) ? up : '';
        s02s00f = parseFloat(init.s02s00) > parseFloat(last.s02s00) ? down : parseFloat(init.s02s00) < parseFloat(last.s02s00) ? up : '';
        s02s01f = parseFloat(init.s02s01) > parseFloat(last.s02s01) ? down : parseFloat(init.s02s01) < parseFloat(last.s02s01) ? up : '';
        s03s00f = parseFloat(init.s03s00) > parseFloat(last.s03s00) ? down : parseFloat(init.s03s00) < parseFloat(last.s03s00) ? up : '';
        s03s01f = parseFloat(init.s03s01) > parseFloat(last.s03s01) ? down : parseFloat(init.s03s01) < parseFloat(last.s03s01) ? up : '';
        s03s02f = parseFloat(init.s03s02) > parseFloat(last.s03s02) ? down : parseFloat(init.s03s02) < parseFloat(last.s03s02) ? up : '';
        s04s00f = parseFloat(init.s04s00) > parseFloat(last.s04s00) ? down : parseFloat(init.s04s00) < parseFloat(last.s04s00) ? up : '';
        s04s01f = parseFloat(init.s04s01) > parseFloat(last.s04s01) ? down : parseFloat(init.s04s01) < parseFloat(last.s04s01) ? up : '';
        s04s02f = parseFloat(init.s04s02) > parseFloat(last.s04s02) ? down : parseFloat(init.s04s02) < parseFloat(last.s04s02) ? up : '';
        s05s00f = parseFloat(init.s05s00) > parseFloat(last.s05s00) ? down : parseFloat(init.s05s00) < parseFloat(last.s05s00) ? up : '';
        s05s01f = parseFloat(init.s05s01) > parseFloat(last.s05s01) ? down : parseFloat(init.s05s01) < parseFloat(last.s05s01) ? up : '';
        s05s02f = parseFloat(init.s05s02) > parseFloat(last.s05s02) ? down : parseFloat(init.s05s02) < parseFloat(last.s05s02) ? up : '';
        s00s00f = parseFloat(init.s00s00) > parseFloat(last.s00s00) ? down : parseFloat(init.s00s00) < parseFloat(last.s00s00) ? up : '';
        s01s01f = parseFloat(init.s01s01) > parseFloat(last.s01s01) ? down : parseFloat(init.s01s01) < parseFloat(last.s01s01) ? up : '';
        s02s02f = parseFloat(init.s02s02) > parseFloat(last.s02s02) ? down : parseFloat(init.s02s02) < parseFloat(last.s02s02) ? up : '';
        s03s03f = parseFloat(init.s03s03) > parseFloat(last.s03s03) ? down : parseFloat(init.s03s03) < parseFloat(last.s03s03) ? up : '';
        s00s01f = parseFloat(init.s00s01) > parseFloat(last.s00s01) ? down : parseFloat(init.s00s01) < parseFloat(last.s00s01) ? up : '';
        s00s02f = parseFloat(init.s00s02) > parseFloat(last.s00s02) ? down : parseFloat(init.s00s02) < parseFloat(last.s00s02) ? up : '';
        s01s02f = parseFloat(init.s01s02) > parseFloat(last.s01s02) ? down : parseFloat(init.s01s02) < parseFloat(last.s01s02) ? up : '';
        s00s03f = parseFloat(init.s00s03) > parseFloat(last.s00s03) ? down : parseFloat(init.s00s03) < parseFloat(last.s00s03) ? up : '';
        s01s03f = parseFloat(init.s01s03) > parseFloat(last.s01s03) ? down : parseFloat(init.s01s03) < parseFloat(last.s01s03) ? up : '';
        s02s03f = parseFloat(init.s02s03) > parseFloat(last.s02s03) ? down : parseFloat(init.s02s03) < parseFloat(last.s02s03) ? up : '';
        s00s04f = parseFloat(init.s00s04) > parseFloat(last.s00s04) ? down : parseFloat(init.s00s04) < parseFloat(last.s00s04) ? up : '';
        s01s04f = parseFloat(init.s01s04) > parseFloat(last.s01s04) ? down : parseFloat(init.s01s04) < parseFloat(last.s01s04) ? up : '';
        s02s04f = parseFloat(init.s02s04) > parseFloat(last.s02s04) ? down : parseFloat(init.s02s04) < parseFloat(last.s02s04) ? up : '';
        s00s05f = parseFloat(init.s00s05) > parseFloat(last.s00s05) ? down : parseFloat(init.s00s05) < parseFloat(last.s00s05) ? up : '';
        s01s05f = parseFloat(init.s01s05) > parseFloat(last.s01s05) ? down : parseFloat(init.s01s05) < parseFloat(last.s01s05) ? up : '';
        s02s05f = parseFloat(init.s02s05) > parseFloat(last.s02s05) ? down : parseFloat(init.s02s05) < parseFloat(last.s02s05) ? up : '';
        s1shf = parseFloat(init['s-1shf']) > parseFloat(last['s-1shf']) ? down : parseFloat(init['s-1shf']) < parseFloat(last['s-1shf']) ? up : '';
        s1sdf = parseFloat(init['s-1sdf']) > parseFloat(last['s-1sdf']) ? down : parseFloat(init['s-1sdf']) < parseFloat(last['s-1sdf']) ? up : '';
        s1saf = parseFloat(init['s-1saf']) > parseFloat(last['s-1saf']) ? down : parseFloat(init['s-1saf']) < parseFloat(last['s-1saf']) ? up : '';
        change.push({
          name: "最新:" + last.updateDate + "  " + last.updateTime,
          s01s00: last.s01s00,
          s02s00: last.s02s00,
          s02s01: last.s02s01,
          s03s00: last.s03s00,
          s03s01: last.s03s01,
          s03s02: last.s03s02,
          s04s00: last.s04s00,
          s04s01: last.s04s01,
          s04s02: last.s04s02,
          s05s00: last.s05s00,
          s05s01: last.s05s01,
          s05s02: last.s05s02,
          s00s00: last.s00s00,
          s01s01: last.s01s01,
          s02s02: last.s02s02,
          s03s03: last.s03s03,
          s1sh: last['s-1sh'],
          s1sd: last['s-1sd'],
          s1sa: last['s-1sa'],
          s00s01: last.s00s01,
          s00s02: last.s00s02,
          s01s02: last.s01s02,
          s00s03: last.s00s03,
          s01s03: last.s01s03,
          s02s03: last.s02s03,
          s00s04: last.s00s04,
          s01s04: last.s01s04,
          s02s04: last.s02s04,
          s00s05: last.s00s05,
          s01s05: last.s01s05,
          s02s05: last.s02s05,
          s01s00f: s01s00f,
          s02s00f: s02s00f,
          s02s01f: s02s01f,
          s03s00f: s03s00f,
          s03s01f: s03s01f,
          s03s02f: s03s02f,
          s04s00f: s04s00f,
          s04s01f: s04s01f,
          s04s02f: s04s02f,
          s05s00f: s05s00f,
          s05s01f: s05s01f,
          s05s02f: s05s02f,
          s00s00f: s00s00f,
          s01s01f: s01s01f,
          s02s02f: s02s02f,
          s03s03f: s03s03f,
          s1shf: s1shf,
          s1sdf: s1sdf,
          s1saf: s1saf,
          s00s01f: s00s01f,
          s00s02f: s00s02f,
          s01s02f: s01s02f,
          s0s03f: s00s03f,
          s01s03f: s01s03f,
          s02s03f: s02s03f,
          s00s04f: s00s04f,
          s01s04f: s01s04f,
          s02s04f: s02s04f,
          s00s05f: s00s05f,
          s01s05f: s01s05f,
          s02s05f: s02s05f
        });
        changeList.value = change;
      }
    };

    // 暴露给外部使用的函数
    __expose({
      pushCrsList
    });
    return (_ctx, _cache) => {
      const _component_nut_divider = _resolveComponent("nut-divider");
      const _component_nut_col = _resolveComponent("nut-col");
      const _component_nut_row = _resolveComponent("nut-row");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_nut_divider, {
        "content-position": "left"
      }, {
        default: _withCtx(() => [_createTextVNode("比分")]),
        _: 1
      }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(changeList.value, (change, index) => {
        return _openBlock(), _createBlock(_component_nut_row, {
          key: index
        }, {
          default: _withCtx(() => [_createVNode(_component_nut_row, null, {
            default: _withCtx(() => [_createVNode(_component_nut_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_1, _toDisplayString(change.name), 1)]),
              _: 2
            }, 1024)]),
            _: 2
          }, 1024), _createVNode(_component_nut_row, null, {
            default: _withCtx(() => [_createVNode(_component_nut_col, {
              span: 4
            }, {
              default: _withCtx(() => [_hoisted_2]),
              _: 1
            }), _createVNode(_component_nut_col, {
              span: 4
            }, {
              default: _withCtx(() => [_hoisted_3]),
              _: 1
            }), _createVNode(_component_nut_col, {
              span: 4
            }, {
              default: _withCtx(() => [_hoisted_4]),
              _: 1
            }), _createVNode(_component_nut_col, {
              span: 4
            }, {
              default: _withCtx(() => [_hoisted_5]),
              _: 1
            }), _createVNode(_component_nut_col, {
              span: 4
            }, {
              default: _withCtx(() => [_hoisted_6]),
              _: 1
            }), _createVNode(_component_nut_col, {
              span: 4
            }, {
              default: _withCtx(() => [_hoisted_7]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_nut_row, null, {
            default: _withCtx(() => [_createVNode(_component_nut_col, {
              span: 4
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_createElementVNode("span", _hoisted_9, _toDisplayString(change.s01s00), 1), _createElementVNode("span", _hoisted_10, [_createElementVNode("img", {
                alt: "",
                src: change.s01s00f
              }, null, 8, _hoisted_11)])])]),
              _: 2
            }, 1024), _createVNode(_component_nut_col, {
              span: 4
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_12, [_createElementVNode("span", _hoisted_13, _toDisplayString(change.s02s00), 1), _createElementVNode("span", _hoisted_14, [_createElementVNode("img", {
                alt: "",
                src: change.s02s00f
              }, null, 8, _hoisted_15)])])]),
              _: 2
            }, 1024), _createVNode(_component_nut_col, {
              span: 4
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_16, [_createElementVNode("span", _hoisted_17, _toDisplayString(change.s02s01), 1), _createElementVNode("span", _hoisted_18, [_createElementVNode("img", {
                alt: "",
                src: change.s02s01f
              }, null, 8, _hoisted_19)])])]),
              _: 2
            }, 1024), _createVNode(_component_nut_col, {
              span: 4
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_20, [_createElementVNode("span", _hoisted_21, _toDisplayString(change.s03s00), 1), _createElementVNode("span", _hoisted_22, [_createElementVNode("img", {
                alt: "",
                src: change.s03s00f
              }, null, 8, _hoisted_23)])])]),
              _: 2
            }, 1024), _createVNode(_component_nut_col, {
              span: 4
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_24, [_createElementVNode("span", _hoisted_25, _toDisplayString(change.s03s01), 1), _createElementVNode("span", _hoisted_26, [_createElementVNode("img", {
                alt: "",
                src: change.s03s01f
              }, null, 8, _hoisted_27)])])]),
              _: 2
            }, 1024), _createVNode(_component_nut_col, {
              span: 4
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_28, [_createElementVNode("span", _hoisted_29, _toDisplayString(change.s03s02), 1), _createElementVNode("span", _hoisted_30, [_createElementVNode("img", {
                alt: "",
                src: change.s03s02f
              }, null, 8, _hoisted_31)])])]),
              _: 2
            }, 1024)]),
            _: 2
          }, 1024), _createVNode(_component_nut_row, null, {
            default: _withCtx(() => [_createVNode(_component_nut_col, {
              span: 4
            }, {
              default: _withCtx(() => [_hoisted_32]),
              _: 1
            }), _createVNode(_component_nut_col, {
              span: 4
            }, {
              default: _withCtx(() => [_hoisted_33]),
              _: 1
            }), _createVNode(_component_nut_col, {
              span: 4
            }, {
              default: _withCtx(() => [_hoisted_34]),
              _: 1
            }), _createVNode(_component_nut_col, {
              span: 4
            }, {
              default: _withCtx(() => [_hoisted_35]),
              _: 1
            }), _createVNode(_component_nut_col, {
              span: 4
            }, {
              default: _withCtx(() => [_hoisted_36]),
              _: 1
            }), _createVNode(_component_nut_col, {
              span: 4
            }, {
              default: _withCtx(() => [_hoisted_37]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_nut_row, null, {
            default: _withCtx(() => [_createVNode(_component_nut_col, {
              span: 4
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_38, [_createElementVNode("span", _hoisted_39, _toDisplayString(change.s04s00), 1), _createElementVNode("span", _hoisted_40, [_createElementVNode("img", {
                alt: "",
                src: change.s04s00f
              }, null, 8, _hoisted_41)])])]),
              _: 2
            }, 1024), _createVNode(_component_nut_col, {
              span: 4
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_42, [_createElementVNode("span", _hoisted_43, _toDisplayString(change.s04s01), 1), _createElementVNode("span", _hoisted_44, [_createElementVNode("img", {
                alt: "",
                src: change.s04s01f
              }, null, 8, _hoisted_45)])])]),
              _: 2
            }, 1024), _createVNode(_component_nut_col, {
              span: 4
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_46, [_createElementVNode("span", _hoisted_47, _toDisplayString(change.s04s02), 1), _createElementVNode("span", _hoisted_48, [_createElementVNode("img", {
                alt: "",
                src: change.s04s02f
              }, null, 8, _hoisted_49)])])]),
              _: 2
            }, 1024), _createVNode(_component_nut_col, {
              span: 4
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_50, [_createElementVNode("span", _hoisted_51, _toDisplayString(change.s05s00), 1), _createElementVNode("span", _hoisted_52, [_createElementVNode("img", {
                alt: "",
                src: change.s05s00f
              }, null, 8, _hoisted_53)])])]),
              _: 2
            }, 1024), _createVNode(_component_nut_col, {
              span: 4
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_54, [_createElementVNode("span", _hoisted_55, _toDisplayString(change.s05s01), 1), _createElementVNode("span", _hoisted_56, [_createElementVNode("img", {
                alt: "",
                src: change.s05s01f
              }, null, 8, _hoisted_57)])])]),
              _: 2
            }, 1024), _createVNode(_component_nut_col, {
              span: 4
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_58, [_createElementVNode("span", _hoisted_59, _toDisplayString(change.s05s02), 1), _createElementVNode("span", _hoisted_60, [_createElementVNode("img", {
                alt: "",
                src: change.s05s02f
              }, null, 8, _hoisted_61)])])]),
              _: 2
            }, 1024)]),
            _: 2
          }, 1024), _createVNode(_component_nut_row, null, {
            default: _withCtx(() => [_createVNode(_component_nut_col, {
              span: 6
            }, {
              default: _withCtx(() => [_hoisted_62]),
              _: 1
            }), _createVNode(_component_nut_col, {
              span: 6
            }, {
              default: _withCtx(() => [_hoisted_63]),
              _: 1
            }), _createVNode(_component_nut_col, {
              span: 6
            }, {
              default: _withCtx(() => [_hoisted_64]),
              _: 1
            }), _createVNode(_component_nut_col, {
              span: 6
            }, {
              default: _withCtx(() => [_hoisted_65]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_nut_row, null, {
            default: _withCtx(() => [_createVNode(_component_nut_col, {
              span: 6
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_66, [_createElementVNode("span", _hoisted_67, _toDisplayString(change.s00s00), 1), _createElementVNode("span", _hoisted_68, [_createElementVNode("img", {
                alt: "",
                src: change.s00s00f
              }, null, 8, _hoisted_69)])])]),
              _: 2
            }, 1024), _createVNode(_component_nut_col, {
              span: 6
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_70, [_createElementVNode("span", _hoisted_71, _toDisplayString(change.s01s01), 1), _createElementVNode("span", _hoisted_72, [_createElementVNode("img", {
                alt: "",
                src: change.s01s01f
              }, null, 8, _hoisted_73)])])]),
              _: 2
            }, 1024), _createVNode(_component_nut_col, {
              span: 6
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_74, [_createElementVNode("span", _hoisted_75, _toDisplayString(change.s02s02), 1), _createElementVNode("span", _hoisted_76, [_createElementVNode("img", {
                alt: "",
                src: change.s02s02f
              }, null, 8, _hoisted_77)])])]),
              _: 2
            }, 1024), _createVNode(_component_nut_col, {
              span: 6
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_78, [_createElementVNode("span", _hoisted_79, _toDisplayString(change.s03s03), 1), _createElementVNode("span", _hoisted_80, [_createElementVNode("img", {
                alt: "",
                src: change.s03s03f
              }, null, 8, _hoisted_81)])])]),
              _: 2
            }, 1024)]),
            _: 2
          }, 1024), _createVNode(_component_nut_row, null, {
            default: _withCtx(() => [_createVNode(_component_nut_col, {
              span: 8
            }, {
              default: _withCtx(() => [_hoisted_82]),
              _: 1
            }), _createVNode(_component_nut_col, {
              span: 8
            }, {
              default: _withCtx(() => [_hoisted_83]),
              _: 1
            }), _createVNode(_component_nut_col, {
              span: 8
            }, {
              default: _withCtx(() => [_hoisted_84]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_nut_row, null, {
            default: _withCtx(() => [_createVNode(_component_nut_col, {
              span: 8
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_85, [_createElementVNode("span", _hoisted_86, _toDisplayString(change.s1sh), 1), _createElementVNode("span", _hoisted_87, [_createElementVNode("img", {
                alt: "",
                src: change.s1shf
              }, null, 8, _hoisted_88)])])]),
              _: 2
            }, 1024), _createVNode(_component_nut_col, {
              span: 8
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_89, [_createElementVNode("span", _hoisted_90, _toDisplayString(change.s1sd), 1), _createElementVNode("span", _hoisted_91, [_createElementVNode("img", {
                alt: "",
                src: change.s1sdf
              }, null, 8, _hoisted_92)])])]),
              _: 2
            }, 1024), _createVNode(_component_nut_col, {
              span: 8
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_93, [_createElementVNode("span", _hoisted_94, _toDisplayString(change.s1sa), 1), _createElementVNode("span", _hoisted_95, [_createElementVNode("img", {
                alt: "",
                src: change.s1saf
              }, null, 8, _hoisted_96)])])]),
              _: 2
            }, 1024)]),
            _: 2
          }, 1024), _createVNode(_component_nut_row, null, {
            default: _withCtx(() => [_createVNode(_component_nut_col, {
              span: 4
            }, {
              default: _withCtx(() => [_hoisted_97]),
              _: 1
            }), _createVNode(_component_nut_col, {
              span: 4
            }, {
              default: _withCtx(() => [_hoisted_98]),
              _: 1
            }), _createVNode(_component_nut_col, {
              span: 4
            }, {
              default: _withCtx(() => [_hoisted_99]),
              _: 1
            }), _createVNode(_component_nut_col, {
              span: 4
            }, {
              default: _withCtx(() => [_hoisted_100]),
              _: 1
            }), _createVNode(_component_nut_col, {
              span: 4
            }, {
              default: _withCtx(() => [_hoisted_101]),
              _: 1
            }), _createVNode(_component_nut_col, {
              span: 4
            }, {
              default: _withCtx(() => [_hoisted_102]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_nut_row, null, {
            default: _withCtx(() => [_createVNode(_component_nut_col, {
              span: 4
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_103, [_createElementVNode("span", _hoisted_104, _toDisplayString(change.s00s01), 1), _createElementVNode("span", _hoisted_105, [_createElementVNode("img", {
                alt: "",
                src: change.s00s01f
              }, null, 8, _hoisted_106)])])]),
              _: 2
            }, 1024), _createVNode(_component_nut_col, {
              span: 4
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_107, [_createElementVNode("span", _hoisted_108, _toDisplayString(change.s00s02), 1), _createElementVNode("span", _hoisted_109, [_createElementVNode("img", {
                alt: "",
                src: change.s00s02f
              }, null, 8, _hoisted_110)])])]),
              _: 2
            }, 1024), _createVNode(_component_nut_col, {
              span: 4
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_111, [_createElementVNode("span", _hoisted_112, _toDisplayString(change.s01s02), 1), _createElementVNode("span", _hoisted_113, [_createElementVNode("img", {
                alt: "",
                src: change.s01s02f
              }, null, 8, _hoisted_114)])])]),
              _: 2
            }, 1024), _createVNode(_component_nut_col, {
              span: 4
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_115, [_createElementVNode("span", _hoisted_116, _toDisplayString(change.s00s03), 1), _createElementVNode("span", _hoisted_117, [_createElementVNode("img", {
                alt: "",
                src: change.s00s03f
              }, null, 8, _hoisted_118)])])]),
              _: 2
            }, 1024), _createVNode(_component_nut_col, {
              span: 4
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_119, [_createElementVNode("span", _hoisted_120, _toDisplayString(change.s01s03), 1), _createElementVNode("span", _hoisted_121, [_createElementVNode("img", {
                alt: "",
                src: change.s01s03f
              }, null, 8, _hoisted_122)])])]),
              _: 2
            }, 1024), _createVNode(_component_nut_col, {
              span: 4
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_123, [_createElementVNode("span", _hoisted_124, _toDisplayString(change.s02s03), 1), _createElementVNode("span", _hoisted_125, [_createElementVNode("img", {
                alt: "",
                src: change.s02s03f
              }, null, 8, _hoisted_126)])])]),
              _: 2
            }, 1024)]),
            _: 2
          }, 1024), _createVNode(_component_nut_row, null, {
            default: _withCtx(() => [_createVNode(_component_nut_col, {
              span: 4
            }, {
              default: _withCtx(() => [_hoisted_127]),
              _: 1
            }), _createVNode(_component_nut_col, {
              span: 4
            }, {
              default: _withCtx(() => [_hoisted_128]),
              _: 1
            }), _createVNode(_component_nut_col, {
              span: 4
            }, {
              default: _withCtx(() => [_hoisted_129]),
              _: 1
            }), _createVNode(_component_nut_col, {
              span: 4
            }, {
              default: _withCtx(() => [_hoisted_130]),
              _: 1
            }), _createVNode(_component_nut_col, {
              span: 4
            }, {
              default: _withCtx(() => [_hoisted_131]),
              _: 1
            }), _createVNode(_component_nut_col, {
              span: 4
            }, {
              default: _withCtx(() => [_hoisted_132]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_nut_row, null, {
            default: _withCtx(() => [_createVNode(_component_nut_col, {
              span: 4
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_133, [_createElementVNode("span", _hoisted_134, _toDisplayString(change.s00s04), 1), _createElementVNode("span", _hoisted_135, [_createElementVNode("img", {
                alt: "",
                src: change.s00s04f
              }, null, 8, _hoisted_136)])])]),
              _: 2
            }, 1024), _createVNode(_component_nut_col, {
              span: 4
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_137, [_createElementVNode("span", _hoisted_138, _toDisplayString(change.s01s04), 1), _createElementVNode("span", _hoisted_139, [_createElementVNode("img", {
                alt: "",
                src: change.s01s04f
              }, null, 8, _hoisted_140)])])]),
              _: 2
            }, 1024), _createVNode(_component_nut_col, {
              span: 4
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_141, [_createElementVNode("span", _hoisted_142, _toDisplayString(change.s02s04), 1), _createElementVNode("span", _hoisted_143, [_createElementVNode("img", {
                alt: "",
                src: change.s02s04f
              }, null, 8, _hoisted_144)])])]),
              _: 2
            }, 1024), _createVNode(_component_nut_col, {
              span: 4
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_145, [_createElementVNode("span", _hoisted_146, _toDisplayString(change.s00s05), 1), _createElementVNode("span", _hoisted_147, [_createElementVNode("img", {
                alt: "",
                src: change.s00s05f
              }, null, 8, _hoisted_148)])])]),
              _: 2
            }, 1024), _createVNode(_component_nut_col, {
              span: 4
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_149, [_createElementVNode("span", _hoisted_150, _toDisplayString(change.s01s05), 1), _createElementVNode("span", _hoisted_151, [_createElementVNode("img", {
                alt: "",
                src: change.s01s05f
              }, null, 8, _hoisted_152)])])]),
              _: 2
            }, 1024), _createVNode(_component_nut_col, {
              span: 4
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_153, [_createElementVNode("span", _hoisted_154, _toDisplayString(change.s02s05), 1), _createElementVNode("span", _hoisted_155, [_createElementVNode("img", {
                alt: "",
                src: change.s02s05f
              }, null, 8, _hoisted_156)])])]),
              _: 2
            }, 1024)]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1024);
      }), 128))], 64);
    };
  }
};